import moment from 'moment'

export default {
  moment(date) {
    return moment(date).format('DD/MM/YYYY')
  },

  dateTime(date) {
    if (date) {
      const time = date.split('T')[1]
      if (time != '00:00:00' && time != undefined) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      }
      return moment(date).format('DD/MM/YYYY')
    }
  },

  dateDiff(date1) {
    const now = moment(new Date())
    const past = moment(date1)
    const duration = moment.duration(now.diff(past))

    return parseInt(duration.asDays())
  },

  nowDatetimeFormat(date) {
    if (!date) return null
    const m = moment(date)
    return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : null
  },

  nowFormat(date) {
    return moment(date).format('YYYY-MM-DD')
  },

  addMonths(date, months) {
    return moment(date, 'DD/MM/YYYY').add(months, 'month')
  },

  addDays(date, days) {
    return moment(date, 'DD/MM/YYYY').add(days, 'days')
  },

  removeDays(date, days) {
    return moment(date, 'DD/MM/YYYY').subtract(days, 'days')
  },

  startOfWeek(date) {
    return moment(date).startOf('week').add(1, 'day')
  },

  endOfWeek(date) {
    return moment(date).endOf('week')
  },

  compareDateTime(dateTime) {
    return moment(dateTime).isAfter(new Date())
  },

  getMoth(date) {
    return moment(date).month()
  },

  getYear(date) {
    return moment(date).year()
  },

  getFirstDayLastMonth(date) {
    const lastMonth = moment(date).subtract(1, 'month')
    return moment(lastMonth).startOf('month').format('DD/MM/YYYY')
  },

  getEndDayLastMonth(date) {
    const lastMonth = moment(date).subtract(1, 'month')
    return moment(lastMonth).endOf('month').format('DD/MM/YYYY')
  },

  getLastDay(date) {
    return moment(date).endOf('month')
  },

  getTime(date) {
    return moment(date).format('HH:mm')
  },
}
